import * as React from 'react';
import { makeStyles } from '@mui/styles';
import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&>div': {
      width: 30,
      height: 30,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: theme.palette.background.paper,
      borderRadius: '99em',
    },
  },
}));


/** 載入動畫 */
export function Loading(props) {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <Box>
        <CircularProgress
          size={(props.size ? props.size : 20)}
          thickness={4.2}
          title='loading'
        />
      </Box>
    </Box>
  );
}